import React, { useState, useEffect, useContext } from 'react';
import { useSelector, useDispatch } from '../../../redux/store';
import { setteamFilter, setstatusFilter, setrunnerFilter, settagFilter, setsearchTerm, setinputValue, setSortDirection, setSortColumn, setCurrentPage, setScrollPos, setLastStatus } from '../../../redux/slices/filters';
import ProjectListTable from './ProjectListTable';
import SearchBar from '../../../Components/SearchBar/SearchBar';
import ProjectTablePagination from './ProjectTablePagination';
import AdminContext from '../../../Context/adminContext';
import { useMsal } from "@azure/msal-react";
import { Box, CircularProgress, Button } from '@mui/material';
import FileDownloadIcon from '@mui/icons-material/FileDownload';
import './ProjectList.css';
import Filter from '../../../Components/Filter/Filter';
import { exportButtonSx } from '../../../GlobalStyles/buttonStyles';

import {
  getProjectList,
  setProjectListData,
  setProjectListRowCount,
  setProjectListLoading,
  fetchFullProjectExport,
  fetchPhasesExport,
} from "../../../redux/slices/project";
import Dropdown from '../../../Components/DropDownBox/Dropdown';
import {
  fetchProjectRunnerOptions,
  fetchProjectStatusOptions,
  fetchProjectTagOptions,
  fetchProjectTeamOptions,
} from '../../../redux/slices/projectListOptions';

function Projects() {
  const { accounts } = useMsal();
  const dispatch = useDispatch();
  const account = accounts[0];

  const admin = useContext(AdminContext);

  const [rowsPerPage, setRowsPerPage] = useState(50);

  const [teamOptions, setTeamOptions] = useState([]);
  const [statusOptions, setStatusOptions] = useState([]);
  const [runnerOptions, setRunnerOptions] = useState([]);
  const [tagOptions, setTagOptions] = useState([]);

  const [paginationLoading, setPaginationLoading] = useState(false);

  const [fetchedTeam, setFetchedTeam] = useState('');
  const listBoxRef = React.useRef();

  let allRows = useSelector((state) => state.project.rows);
  let totalRows = useSelector((state) => state.project.totalRows);

  let loading = useSelector((state) => state.project.loading);

  let scrollPos = useSelector((state) => state.filters.scrollPos);

  const searchTerm = useSelector((state) => state.filters.searchTerm);
  const teamFilter = useSelector((state) => state.filters.teamFilter);
  const statusFilter = useSelector((state) => state.filters.statusFilter);
  const runnerFilter = useSelector((state) => state.filters.runnerFilter);
  const tagFilter = useSelector((state) => state.filters.tagFilter);
  const inputValue = useSelector((state) => state.filters.inputValue);
  const sortDirection = useSelector((state) => state.filters.sortDirection);
  const sortColumn = useSelector((state) => state.filters.sortColumn);
  const currentPage = useSelector((state) => state.filters.currentPage);

  const LastStatus = useSelector((state) => state.filters.LastStatus);

  const [projectExportLoading, setProjectExportLoading] = useState(false);
  const [phaseExportLoading, setPhaseExportLoading] = useState(false);

  const fetchTeamOptions = async () => {
    try {
      const teams = await dispatch(fetchProjectTeamOptions()).unwrap();
      const transformedData = (Array.isArray(teams) ? teams : []).map(team => ({ name: team, value: team }));
      transformedData.unshift({ name: 'All', value: 'All' });
      setTeamOptions(transformedData);
      console.log("team", transformedData)
    } catch (error) {
      console.error('Error fetching teams:', error);
    }
  };

  const fetchRunnerOptions = async () => {
    try {
      const runners = await dispatch(fetchProjectRunnerOptions()).unwrap();
      const transformedData = (Array.isArray(runners) ? runners : []).map(runner => ({ name: runner, value: runner, team: runner }));
      transformedData.unshift({ name: 'All', value: 'All', team: 'None' });
      setRunnerOptions(transformedData);
      console.log(transformedData)
    } catch (error) {
      console.error('Error fetching runners:', error);
    }
  };

  const fetchTagOptions = async () => {
    try {
      const tags = await dispatch(fetchProjectTagOptions()).unwrap();
      const transformedData = (Array.isArray(tags) ? tags : []).map(tag => ({ name: tag, value: tag }));
      transformedData.unshift({ name: 'All', value: 'All' });
      setTagOptions(tags);
    } catch (error) {
      console.error('Error fetching tag:', error);
    }
  };

  const fetchStatuses = async () => {
    try {
      const statuses = await dispatch(fetchProjectStatusOptions()).unwrap();
      const transformedData = (Array.isArray(statuses) ? statuses : []).map(status => ({
        name: status,
        value: status.replace(/-/g, " ")
      }));
      transformedData.unshift({ name: 'All - Open', value: '' });
      transformedData.unshift({ name: 'All - Projects', value: 'All - Projects' });
      setStatusOptions(transformedData);
    } catch (error) {
      console.error('Error fetching statuses:', error);
    }
  };

  const loadData = async () => {
    try {

      // Uncomment when multiple teams exist again
      // const team = teamFilter !== '' ? teamFilter : await fetchTeam();

      // if (team === "Devs" || team === "Fields") {
      //   setFetchedTeam("All");
      // } else {
      //   setFetchedTeam(team);
      // }


      // Remove the below line when multiple teams exist again
      setFetchedTeam("All");
      const team = "Devs"

      dispatch(getProjectList(currentPage, rowsPerPage, searchTerm, team, statusFilter, sortColumn, sortDirection, runnerFilter, tagFilter));

      setPaginationLoading(false);
    } catch (error) {
      console.error(error);
      dispatch(setProjectListLoading(false));
      setPaginationLoading(false);
    }
  };

  useEffect(() => {
    fetchTeamOptions();
    fetchStatuses();
    fetchRunnerOptions();
    fetchTagOptions();
  }, []);

  useEffect(() => {
    loadData();
  }, [searchTerm, sortColumn, sortDirection, statusFilter, runnerFilter, tagFilter, currentPage, rowsPerPage, teamFilter]);

  useEffect(() => {
    dispatch(setLastStatus(statusFilter));
  }, [statusFilter])

  const handleSearch = (event) => {
    dispatch(setinputValue(event.target.value));
  };

  const handleSearchSubmit = () => {
    dispatch(setsearchTerm(inputValue));
    dispatch(setCurrentPage(1));
  };

  const handleTeamFilter = (team) => {
    console.log(`handleTeamFilter called with team: ${team}`);
    if (team === "Devs" || team === "Fields") {
      team = ""
      dispatch(setteamFilter(team));
    } else {
      dispatch(setteamFilter(team));
    }
    dispatch(setCurrentPage(1));

    // Save scroll position
    if (listBoxRef.current) {
      dispatch(setScrollPos(listBoxRef.current.scrollTop));
    }

    if (team.toLowerCase() !== "all" && team.toLowerCase() !== "") {
      dispatch(setSortColumn('nextdeadline'));
      setSortDirection('asc');
    } else if ((team.toLowerCase() == "all" || team.toLowerCase() == "") && statusFilter.toLowerCase() == "live") {
      dispatch(setSortColumn('promoted'));
      dispatch(setSortDirection('asc'));
    }
  };

  const handleStatusFilter = (status) => {
    dispatch(setstatusFilter(status));
    dispatch(setCurrentPage(1));
  };

  const handleRunnerFilter = (runner) => {
    dispatch(setrunnerFilter(runner));
    dispatch(setCurrentPage(1));
  };

  const handleTagFilter = (tag) => {
    dispatch(settagFilter(tag));
    dispatch(setCurrentPage(1));
  };

  const handleSort = (column) => {
    if (column === sortColumn) {
      dispatch(setSortDirection(sortDirection === 'asc' ? 'desc' : 'asc'));
    } else {
      dispatch(setSortColumn(column));
      dispatch(setSortDirection('asc'));
    }
  };

  const handlePrevPage = () => {
    if (currentPage > 1) {
      setPaginationLoading(true);
      dispatch(setCurrentPage(currentPage - 1));
    }
  };

  const handleNextPage = () => {
    if (currentPage < totalPages) {
      setPaginationLoading(true);
      dispatch(setCurrentPage(currentPage + 1));
    }
  };

  const handlePageChange = (pageNumber) => {
    if (pageNumber >= 1 && pageNumber <= totalPages && pageNumber !== currentPage) {
      setPaginationLoading(true);
      dispatch(setCurrentPage(pageNumber));
    }
  };

  const handleKeyDown = (event) => {
    if (event.key === 'Enter') {
      handleSearchSubmit();
    }
  };

  React.useEffect(() => {
    // Restore scroll position
    if (scrollPos && listBoxRef.current) {
      listBoxRef.current.scrollTop = parseFloat(scrollPos);
    }
  }, [scrollPos]);


  const totalPages = totalRows > 0 ? Math.ceil(totalRows / rowsPerPage) : 0;
  const currentPageValue = totalRows > 0 ? currentPage : 0;

  const handleProjectExportClick = async () => {
    setProjectExportLoading(true);
    try {
      await dispatch(fetchFullProjectExport());
      // Optionally show success message
    } catch (error) {
      // Optionally show error message
      console.error("Project export failed:", error);
    } finally {
      setProjectExportLoading(false);
    }
  };

  const handlePhaseExportClick = async () => {
    setPhaseExportLoading(true);
    try {
      await dispatch(fetchPhasesExport());
      // Optionally show success message
    } catch (error) {
      // Optionally show error message
      console.error("Phase export failed:", error);
    } finally {
      setPhaseExportLoading(false);
    }
  };

  return (
    <div className='projectContent'>
      <div className='ProjectHeader'>
        <div className='Projecttitle'>Project List</div>
        <div className='ButtonGroup'>
          {admin &&
            <React.Fragment>
              <Button
                variant="contained"
                onClick={handleProjectExportClick}
                disabled={loading || projectExportLoading || phaseExportLoading}
                startIcon={<FileDownloadIcon sx={{ fontSize: '16px' }}/>}
                sx={{ ...exportButtonSx, marginRight: '10px' }}
              >
                {projectExportLoading ? 'Exporting...' : 'Project Export'}
              </Button>

              <Button
                variant="contained"
                onClick={handlePhaseExportClick}
                disabled={loading || projectExportLoading || phaseExportLoading}
                startIcon={<FileDownloadIcon sx={{ fontSize: '16px' }}/>}
                sx={exportButtonSx}
              >
                {phaseExportLoading ? 'Exporting...' : 'Phase Export'}
              </Button>
            </React.Fragment>
          }
        </div>
      </div>
      <div className='ProjectTableFilters'>
        <div className='StatusNdTeam'>
          <div className='ProjectTeamFilter'>
            <label className='FilterLabel' htmlFor='teamFilter' style={{ fontSize: '12px' }}>Team:</label>
            <Filter id='teamFilter' Options={teamOptions} selectedOption={fetchedTeam} onSelect={handleTeamFilter} disabled={loading} />
          </div>

          <React.Fragment>
            <div className='ProjectStatusFilter'>
              <label className='FilterLabel' htmlFor='statusFilter' style={{ fontSize: '12px' }}>Status:</label>
              <Filter id='statusFilter' Options={statusOptions} selectedOption={statusFilter === "" ? "All - Open" : statusFilter} onSelect={handleStatusFilter} disabled={loading} />
            </div>

            <div className='ProjectStatusFilter'>
              <label className='FilterLabel' htmlFor='RunnerLabel' style={{ fontSize: '12px' }}>Runner:</label>
              <Filter id='RunnerLabel' Options={runnerOptions} selectedOption={runnerFilter} onSelect={handleRunnerFilter} disabled={loading} />
            </div>

            <div className='ProjectStatusFilter'>
              <label className='FilterLabel' htmlFor='TagLabel' style={{ fontSize: '12px' }}>Tags:</label>
              <Dropdown id='TagLabel' options={tagOptions} initialSelectedValue={tagFilter} onValueChange={handleTagFilter} disabled={loading} PopUp={false} options_width='110%' mode='multi' />
            </div>
          </React.Fragment>

        </div>

        <div className='ProjectListSearch'>
          <SearchBar value={inputValue} onChange={handleSearch} onKeyDown={handleKeyDown} disabled={loading} onClick={handleSearchSubmit} />
        </div>
      </div>

      {loading ? (
        <>
          <div className='ProjectListBox'>
            <ProjectListTable
              rows={[]} // Send empty rows while loading
              status={statusFilter}
              sortColumn={sortColumn}
              sortDirection={sortDirection}
              handleSort={handleSort}
              loading={loading} // Send loading status to ProjectListTable
            />
          </div>

          <ProjectTablePagination
            currentPage={currentPageValue}
            totalPages={totalPages}
            onPrevPage={paginationLoading ? null : handlePrevPage} // disable if loading
            onNextPage={paginationLoading ? null : handleNextPage} // disable if loading
            rowsShown={allRows.length}
            totalRows={totalRows}
            rowsPerPage={rowsPerPage}
            loading={loading}
            onPageChange={handlePageChange}
          />
        </>
      ) : (
        <>
          <div className='ProjectListBox' ref={listBoxRef}>
            <ProjectListTable
              rows={allRows}
              status={statusFilter}
              loading={loading}
              handleSort={handleSort}
              sortDirection={sortDirection}
              sortColumn={sortColumn}
            />

          </div>

          {allRows.length === 0 && <div className='NoProjects'>THE RECORD YOU HAVE SEARCHED CANNOT BE FOUND</div>}

          <ProjectTablePagination
            currentPage={currentPageValue}
            totalPages={totalPages}
            onPrevPage={paginationLoading ? null : handlePrevPage} // disable if loading
            onNextPage={paginationLoading ? null : handleNextPage} // disable if loading
            rowsShown={allRows.length}
            totalRows={totalRows}
            rowsPerPage={rowsPerPage}
            onPageChange={handlePageChange}
          />

        </>
      )}
    </div>
  );

}

export default Projects;